// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFunction(value: any): value is (...args: any[]) => any {
  return value && {}.toString.call(value) === '[object Function]'
}
